import { upperFirst } from 'lodash';
import { generatorCategories } from '../../data/data.generators';

export const calculateMeta = (generator: IGenerator): IGeneratorMeta => {
  const output: IGeneratorMeta = {
    parametersCount: 0,
    groupsCount: 0,
    slotsCount: 0,
    cost: 0,
    category: '',
    categoryDescription: '',
    complexityLevel: 0,
  };

  const { id, parameters = [], groups = [], slots, tags = [], type } = generator;
  const { active = [] } = slots ?? {};

  const parametersCount = parameters.length;
  const groupsCount = groups.length;
  const slotsCount = active.length;

  const cat = generatorCategories.find((cat) => tags.includes(cat.name));
  if (cat) {
    output.category = upperFirst(cat.name);
    output.categoryDescription = cat.description;
  } else {
    output.category = 'Misc';
    output.categoryDescription = 'Miscellaneous objects';
  }

  output.parametersCount = parametersCount;
  output.groupsCount = groupsCount;
  output.slotsCount = slotsCount;

  const complexityLevel = Math.min(5, Math.ceil((parametersCount - 9) / 8) + 1);

  output.cost = complexityLevel * 40;
  output.complexityLevel = complexityLevel;

  return output;
};
